var map = {
	"./ico_dagou.svg": "0a48",
	"./ico_dagou@2x.png": "edb2",
	"./pic_pdf_big.png": "87d6",
	"./pic_pdf_big@2x.png": "5702",
	"./pic_ppt_big.png": "3fb1",
	"./pic_ppt_big@2x.png": "dab5",
	"./pic_ship_big.png": "dcfc",
	"./pic_ship_big@2x.png": "ab28",
	"./pic_tupianyasuo_big.png": "f92f",
	"./pic_tupianyasuo_big@2x.png": "f4a7",
	"./pic_word_big.png": "6914",
	"./pic_word_big@2x.png": "0167"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f048";